import React from 'react';
import {
  ListButton,
  SaveButton,
  Toolbar,
  useDataProvider,
  useNotify,
  useRedirect,
  useRefresh,
} from 'react-admin';
import { useSelector } from 'react-redux';
import {
  checkDiscountPreviousValue,
  checkDiscountValues,
  checkFillDiscount,
  checkFillDiscountRates,
  checkIsCash,
} from '../../helpers/checkDiscount';
import {
  checkCreditsDateError,
  checkIsDatesValid,
} from '../../helpers/checkDreamHome';
import { FixedOdds } from '../../types/fixedOdds';
import { Prize } from '../../types/prize';
import { TicketRatesDiscount } from '../../types/property';
import { CreditProps } from '../common/generalPickersBlocks/credits/CreditsPickerComponent';

const WeeklySubscriptionDrawToolbar = (
  props,
  isCreate: boolean,
  handleImagesError: Function,
  discountFillError,
  setIsDiscountValidate,
  handleSetCountdownError,
  creditsData: {
    creditsArr: Array<CreditProps>;
    dateType: string;
    creditsStatus: boolean;
    creditsStartDate: Date | string | undefined;
    creditsEndDate: Date | string | undefined;
  },
  countdownStartDate: Date | string,
  countdownEndDate: Date | string,
  prize: Prize | undefined
) => {
  const notify = useNotify();
  const refresh = useRefresh();
  const redirect = useRedirect();
  const stateApp = useSelector((state) => state);
  const dataProvider = useDataProvider();

  const location = props.location.pathname.split('/');
  const path = location[location.length - 1] === '1' ? '1' : '';
  const id = props.id ? props.id + '/' : 'create/';

  const handleSave = async (data) => {
    // const images = stateApp.property.galleryFiles;
    // const imagesMobile = stateApp.property.galleryFilesMobile;

    if (stateApp.property.isNew) {
      isCreate = true;
    }

    // if (path === '') {
    //   redirect(`/weeklySubscriptionDraws/${id}1`);
    //   return;
    // }

    let fixedOdds: any = {
      description: data.description,
      title: data.title.replace(/\s+/g, ' ').trim(),
      active: data.active || false,
      id: data.id || '',
      photoUrlKeys: [],
      photoUrlKeysMobile: [],
      startAt: countdownStartDate,
      endsAt: countdownEndDate,
      metaTitle: data.metaTitle,
      metaDescription: data.metaDescription,
    };

    const isCountdownDateError = checkIsDatesValid(
      fixedOdds.startAt,
      fixedOdds.endsAt
    );
    if (isCountdownDateError) {
      handleSetCountdownError(true);
    }

    try {
      const newFixedOdds = isCreate
        ? await dataProvider.create('weeklySubscriptionDraws', {
            data: fixedOdds,
          })
        : await dataProvider.update('weeklySubscriptionDraws', {
            data: fixedOdds,
            id: props.id,
            previousData: {} as any,
          });
      if (!newFixedOdds.data) {
        notify('something went wrong', 'error');
      }
      // const result = await dataProvider.storeImages(
      //   { source: 'weeklySubscriptionDraws', id: newFixedOdds.data.result._id },
      //   { images, imagesMobile }
      // );
      // if (!result.data) {
      //   notify('something went wrong', 'error');
      // }

      notify(`Weekly Subscription Draw ${isCreate ? 'saved' : 'updated'}`);
      redirect('/weeklySubscriptionDraws');
    } catch (error) {
      notify(error.data.error.toString().split(':')[1], 'error');
    }
  };

  return (
    <Toolbar {...props} className='buttons-wrapper'>
      <SaveButton className='save-button' onSave={handleSave} />
      <ListButton className='cancel-button' label='Cancel'>
        <div>Cancel</div>
      </ListButton>
    </Toolbar>
  );
};

export default WeeklySubscriptionDrawToolbar;
